export default {
    nav: {
        ReserveGift: 'นัดรับรางวัล',
        FollowFbRaffle: 'ติดตามFBลุ้นรับรางวัล',
        CharacterIntroduction: 'แนะนำตัวละคร',
        Gameplay: 'แนะนำเกม',
        AttentionFB: 'ติดตามเพจ FB',
        DownloadGift: 'ดาวน์โหลดเพื่อรับรางวัล',
    },
    first: {
        ShopReserve: 'ลงทะเบียนล่วงหน้าเพื่อรับสุ่ม2024ครั้ง',
        ShopDown: 'ดาวน์โหลดเพื่อรับสุ่ม2024ครั้ง',
        PhoneReserve: 'จองล่วงหน้าบนมือถือรับฮีโร่ SR',
        PhoneDown: 'ดาวน์โหลดบนมือถือรับฮีโร่ SR',
        Reserve: 'ลงทะเบียนล่วงหน้า',
        Down: 'ดาวน์โหลดเลย',
        PraiseAward: 'กดไลค์เพจ FB รับรางวัล',
        PraiseGift: 'กดไลค์เพจ FBเพื่อรับรางวัล',
    },
    reach: {
        NumberOfPeople: 'จำนวนผู้จอง',
        Achieved: 'บรรลุ',
        NotAchieved: 'ยังไม่บรรลุ',
        Unit: 'Kคน',
        ServiceReward: 'หลังบรรลุเป้าหมายการลงทะเบียนแล้ว จะส่งรางวัลทั่วเซิร์ฟ',
        SlimageAwards: 'ไปที่แบ่งปันรางวัล',
    },
    other: {
        GameIntroduction: 'แนะนำเกม',
        CommunityInformation: 'ข้อมูลชุมชน',
        MoreGift: 'กดไลค์เพจ FBเพื่อรับรางวัลมากมาย',
        PleaseEnter: "โปรดกรอกเบอร์โทรศัพท์ที่ถูกต้อง!",
        Expect: "พบกันเร็ว ๆ นี้",
        restrict: "กรุณาอย่าลงทะเบียนบ่อยครั้ง",
    },
    side: {
        ReservationNow: 'ลงทะเบียนตอนนี้เพื่อรับสุ่ม2024ครั้ง',
        FollowFbRaffle: 'ติดตามเพจFBลุ้นรับรางวัล',
        Down: 'ดาวน์โหลดตอนนี้เพื่อรับสุ่ม2024ครั้ง'
    },
    popups: {
        LimitedTime: 'ลงทะเบียนภายใน 30 วิ. เพื่อรับสุ่ม2024ครั้ง',
        AddReserve: 'ไปที่ร้านจองเพิ่มเพื่อรับสุ่ม2024ครั้ง',
        Get: 'ยินดีด้วยคุณได้รับรางวัลจองทางมือถือ',
        Code: 'โค้ดแพ็ก:',
        Congratulations: 'ยินดีด้วย',
        CompleteStoreAppointment: 'คุณลงทะเบียนร้านสำเร็จ',
        FbCommunity: 'กดไลค์เพจFBเพื่อรับรางวัล',
        GetGoodGift: '',
        Over: 'กิจกรรมจองสิ้นสุดแล้ว',
        PhoneReserveSuccess: 'คุณได้ลงทะเบียนผ่านมือถือสำเร็จแล้ว',
        AddDown: 'ไปที่ร้านดาวน์โหลดเพื่อรับสุ่ม2024ครั้ง'
    }
}
